import React, { useContext } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ModalContext } from '../../../modals/ModalContext';
import NonLoginView from './NonLoginView';
import LoginView from './LoginView';
import DetailedModal from './DetailedModal';
import Button from '../../components/Button/Button';
import { isReferralBonusActive } from '../../../views/Pages/Root/Referral/PromoConfig';

const DetailedModalButton = () => {
  const { openModal } = useContext(ModalContext);

  const showDetailedModal = () => {
    openModal({
      component: <DetailedModal />,
      title: isReferralBonusActive ? <Trans>Share Bake, earn together.</Trans> : <Trans>Welcome Bonus</Trans>,
    });
  };
  return (
    <Button medium btnLink onClick={() => showDetailedModal()}><Trans>Details</Trans></Button>
  );
};

const ReferButton = () => <Link to="/referral" className="ml-3">
  <Button primary medium><Trans>Refer now</Trans></Button>
</Link>;

export default function SignUpBonusBanner({ isLoggedIn = false }) {
  if (isLoggedIn) {
    return <LoginView buttons={
      <>
        <DetailedModalButton />
        <ReferButton />
      </>
    } />;
  }

  return (
    <>
      <NonLoginView buttons={<DetailedModalButton />} />
    </>
  );
}
